import {React, ReactDOM, _n, joinUrl, clickOn} from 'pexui';
import * as utils from '../../utilities/utils';
import {track,setTrackOpts}    from '../../utilities/track';
import {Button} from '../comps/uicomps';
import {messageBox} from '../dialog';
import {DocUploadService} from '../../services/docuploadsvc';
import {registerMessageHandler} from '../../services/msgsvc';
import {stopBusy} from '../comps/busy';
import {Html} from '../comps/html';
import {spinnerStyles} from '../comps/spinner';
import {flow,getTrackLabel} from '../../models/flow';

const LINKEDIN_LOAD_TIMEOUT = 60000; // 1 minute
const BUTTON_DISABLED_SECONDS = 10; // 10 seconds
let windowWatcher = null;
let envelopeId = null;

export const DocuSignPane = ({page, node, widget, flow, className}) => {
    const docuSignHandler = (e)=>{
        const data = e.data;

        if(windowWatcher){
            clearInterval(windowWatcher);
            windowWatcher = null;
        }

        stopBusy();

        // event=signing_complete
        const respObj = utils.parseUrlParams(data.substr(18));

        if(respObj && respObj.event === 'signing_complete'){
            node.files.push({
                type: 'info',
                name: _n('DocuSign.success.message'),
                completedTime: new Date()
            });

            track("DocuSign:Success", {contentName: getTrackLabel(node)});

            DocUploadService.log2Server({
                "transaction_id":  flow.req.transaction_id,
                "type" : "DOCUSIGN",
                "event": respObj.event
            });

            flow.raiseInvokerEvent('docusignResponse', {
                "transaction_id": flow.req.transaction_id,
                "process_control_number"  : flow.req.document_data.process_control_number,
                "submission_channel_code" : "DOCUSIGN",
                "documents_requested_code": node.code,
                "received_timestamp": utils.getTimestamp(),
                "docusign_response" : {
                    "envelope_id": envelopeId
                }
            });

            page.forceUpdate();
        }else{
            const errorCode = respObj && respObj.event || 'service';
            const errorKey = `error.${errorCode}.message`;
            const errorMessage = _n(errorKey);

            DocUploadService.log2Server({
                "transaction_id":  flow.req.transaction_id,
                "type": "DOCUSIGN",
                "error": errorMessage
            });

            setTrackOpts("DocuSign", {productsOption: node.code});
            flow.lastError = errorCode;
            flow.addNodeMessage(node, "!" + errorMessage, errorKey);
            page.forceUpdate();
        }
    };

    const gotoDocuSign = (evt) => {
        flow.lastChannel = 'DOCUSIGN';

        node.messages = [];
        node.docuSignUrl = null;

        const widgetRequest = flow.req;
        const returnURL = joinUrl(utils.getSameDomainBaseUrl(), 'infowidget/docusign/docusignresponse.html#');

        let isIE = false;
        let timeCounter = 0;
        // using var instead of let in order to be accessible from an asynchronous callback.
        var docuSignWnd = null;

        if(utils.isGoodBrowser()){
            docuSignWnd = window.open("", "_blank");
            // Create spinner
            docuSignWnd.document.write("<head><style>" + spinnerStyles + "</style><head>");
            docuSignWnd.document.write("<div id='spinner'<div>");
        }else{
            isIE = true;
            const holder = document.getElementById('px_d_iframe_holder');
            if(holder){
                ReactDOM.render(<iframe name="l_frame"
                        src={joinUrl(utils.getSameDomainBaseUrl(), 'infowidget/docusign/comm.html')}
                        width="300" height="20"
                        frameborder="0"
                    />, holder);
            }else{
                console.error("Fail to find px_d_iframe_holder");
            }
        }

        DocUploadService.getDocuSignUrl(widgetRequest, returnURL)
            .then(resp => {
                const docuSignUrl = resp.docusign_url;
                envelopeId = resp.envelope_id;

                registerMessageHandler([
                    'docusign_response'
                ], docuSignHandler);

                // check if the window is closed every 1 second
                windowWatcher = setInterval(()=>{
                    const windowClosed = (!isIE) && docuSignWnd && docuSignWnd.closed;
                    const timeOut = isIE && (++timeCounter > BUTTON_DISABLED_SECONDS);
                    if(windowClosed || timeOut){
                        clearInterval(windowWatcher);
                        windowWatcher = null;
                        stopBusy();

                        if(windowClosed){
                            const errorKey = 'error.921.message';
                            const errorMessage = _n(errorKey) || 'User cancelled, please try again';

                            setTrackOpts("DocuSign", {contentName: getTrackLabel(node)});
                            flow.lastError = '921';
                            flow.addNodeMessage(node, "!" + errorMessage, errorKey);
                            page.forceUpdate();
                        }
                    }
                }, 1000);

                if(docuSignWnd){
                    docuSignWnd.document.location.href = docuSignUrl;
                }else{
                    setTimeout(()=>{
                        window.open(docuSignUrl, "_blank");
                    }, 1000);
                }

                track("DocuSign:Open", {contentName: getTrackLabel(node)});
            })
            .catch(err => {
                console.log(err);
                // fix: closing the newly opened tab in negative scenario.
                if(docuSignWnd && !docuSignWnd.closed) {
                    docuSignWnd.close();
                }

                stopBusy();

                flow.addNodeMessage(node, err);
                flow.setCurrentNode(node);
                page.forceUpdate();
            });
    };

    return <div className={className}>
        <Button
            id={utils.getUniqueId('infw_btn_docusign', node)}
            className='infw-btn-secondary'
            label={_n('DocuSign.button_label')}
            busyZone="widget"
            onClick={gotoDocuSign}/>
        { node.docuSignUrl?
            <div className="infw-btn-desc">
                <span>{_n('DocuSign.link_desc')}</span>
                <a id="infw_link_docusign" href={node.docuSignUrl} target="_blank">the link</a>.
            </div>
         :
            <Html className='infw-btn-desc'
                content='DocuSign.button_desc' />

        }
        <div id="px_d_iframe_holder"/>
    </div>;
};



// WEBPACK FOOTER //
// ./application/src/views/docusign/docusign.jsx